import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row pb-md-5 pb-3">
          <div className="col-xl-9 col-lg-6 col-md-7 col-sm-12 col-12">
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-10">
                <div className="footer-links">
                  <a href="index.html">
                    <img src="assets/imges/AI-Logo.png" alt="logo" width={100} height={100} />
                  </a>
                  <p className="text-white mt-3 mb-4">
                  Ai-Cook is designed to make cooking effortless with advanced AI that helps you plan meals, scan ingredients, and even reverse cook by analyzing dish photos to generate recipes.
                    {/* Lorem Ipsum&nbsp;is simply dummy text of the printing and
                    typesetting industry.&nbsp;Lorem Ipsum&nbsp;is simply dummy
                    text of the printing and typesetting industry.&nbsp; */}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-5 col-sm-12 col-12  mt-4 mt-md-5">
            <div className="footer-links">
              <h5 className="yellow">Contact Us</h5>
              <ul className="mt-4">
                <li className="mb-4 text-white">
                  <Link to="mailto:info@aicookllc.com" className="text-white">
                    {" "}
                    <span>
                      <i className="fa-solid fa-envelope me-2 mb-2" />
                      Email:
                    </span>
                    <br />
                    <span>info@aicookllc.com</span>
                  </Link>
                </li>
                <li className="mb-4 text-white">
                  <div className="sosial_media mt-1">
                    <h6 className="text-white mb-2">Follow Us</h6>
                    <div className="social_icons">
                      <Link to="https://facebook.com" target="_blank">
                        <i className="fa-brands fa-facebook" />
                      </Link>
                      <Link to="https://instagram.com" target="_blank">
                        <i className="fa-brands fa-instagram" />
                      </Link>
                      <Link to="https://twitter.com" target="_blank">
                        <i className="fa-brands fa-twitter" />
                      </Link>
                      <Link to="https://linkedin.com" target="_blank">
                        <i className="fa-brands fa-linkedin-in" />
                      </Link>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="copy_right text-center">
        <p className="text-white">©2024 AI COOK. All right reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
